import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Initialize GA4 with Measurement ID (wrapped in try-catch for privacy blockers)
const GA_MEASUREMENT_ID = 'G-7MLRTNG1YK';

let isInitialized = false;

const initializeGA = () => {
  if (isInitialized) return;
  
  try {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    isInitialized = true;
  } catch (error) {
    console.warn('Google Analytics initialization failed:', error);
  }
};

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize on first mount
    initializeGA();
  }, []);

  useEffect(() => {
    // Send pageview on every route change (safely)
    try {
      if (isInitialized) {
        ReactGA.send({ 
          hitType: 'pageview', 
          page: location.pathname + location.search 
        });
      }
    } catch (error) {
      console.warn('Google Analytics pageview failed:', error);
    }
  }, [location]);

  // This component renders nothing
  return null;
};

export default AnalyticsTracker;
